import * as React from "react";
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgWhitePaper = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 200 164"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="#fff"
      d="M200 0H58.253S32.719 23.512 32.719 80.673c0 49.159 19.364 115.81 12.094 143.093C39.33 244.352 12.743 247.889 0 248.378h134.92s44.371 2.68 51.641-24.612c7.27-27.293-12.095-93.934-12.095-143.102C174.466 23.474 200 0 200 0"
    />
    <path
      fill="#D8DAD8"
      d="M200 0H58.253S32.719 23.512 32.719 80.673c0 49.159 19.364 115.81 12.094 143.093C39.33 244.352 12.743 247.889 0 248.378h134.92s44.371 2.68 51.641-24.612c7.27-27.293-12.095-93.934-12.095-143.102C174.466 23.474 200 0 200 0"
      opacity={0.7}
    />
    <g fill="#fff" opacity={0.8}>
      <path
        d="M161.441 60.284H48.077c3.207-25.148 11.85-39.782 16.618-46.177h109.31c-5.36 11.192-10.42 26.437-12.564 46.177"
        opacity={0.8}
      />
      <path
        d="M160.491 73.62H46.967c.094-2.285.226-4.505.414-6.65h113.458q-.236 3.245-.348 6.65M82.564 86.946H46.929a237 237 0 0 1-.103-6.273v-.367H82.47v.358c0 2.078.028 4.176.094 6.282M161.168 100.273H47.728a208 208 0 0 1-.479-6.64h113.486q.17 3.3.433 6.64M162.419 113.58H49.074a420 420 0 0 1-.734-6.649H161.78c.16 2.239.395 4.458.64 6.649M164.055 126.935H50.805c-.311-2.22-.603-4.439-.885-6.64h113.289q.394 3.32.846 6.64M165.927 140.261H52.685q-.49-3.328-.94-6.639h113.232c.31 2.21.63 4.411.95 6.639M167.93 153.597H54.726c-.179-1.213-.367-2.445-.555-3.677l-.451-2.972h113.204c.338 2.22.668 4.439 1.006 6.649M56.7 166.924q-.47-3.292-.94-6.64h113.186c.329 2.219.667 4.43.987 6.64z"
        opacity={0.3}
      />
    </g>
  </svg>
);
export default SvgWhitePaper;
